import React from 'react'
import _ from 'underscore'
import { StackView, TileView } from '@planningcenter/tapestry-react'
import { computedToken, token } from '@planningcenter/tapestry'

const VersionPicker = ({
  type,
  defaultValue,
  versions,
  displayAppName,
  appName,
}) => {
  const match = new RegExp('^Error')
  const isDisabled =
    _.any(versions, (v) => match.test(v)) || versions.length === 0
  return (
    <StackView spacing={computedToken('--t-spacing-half')}>
      <label htmlFor={`${type}_${appName}_version`}>{displayAppName}</label>
      <select
        name={`${type}[${appName}_version]`}
        id={`${type}_${appName}_version`}
        defaultValue={defaultValue}
        className="input input--select"
        disabled={isDisabled}
      >
        {_.map(versions, (version) => (
          <option key={version.id} value={version.id}>
            {version.id} {version.attributes.beta && '(beta)'}
          </option>
        ))}
        <option value="latest">Latest</option>
      </select>
    </StackView>
  )
}

class AppVersions extends React.Component {
  render() {
    const {
      type,
      apiVersion,
      apiVersions,
      checkInsVersion,
      checkInsVersions,
      groupsVersion,
      groupsVersions,
      givingVersion,
      givingVersions,
      peopleVersion,
      peopleVersions,
      publishingVersion,
      publishingVersions,
      registrationsVersion,
      registrationsVersions,
      calendarVersion,
      calendarVersions,
      servicesVersion,
      servicesVersions,
    } = this.props
    return (
      <div className="d-f fd-c g-2">
        <h3>Versions</h3>

        <p
          className="fs-sm"
          style={{ color: token('--t-text-color-secondary') }}
        >
          The Planning Center API supports versioning on a per application
          basis. Use this section to manage the default versions of all Planning
          Center Apps.{' '}
          <a
            href="/docs/overview/versioning"
            title="Read More"
            target="_blank"
            rel="noreferrer"
          >
            Read more
          </a>
        </p>

        <TileView minCellWidth={30} spacing={2}>
          <VersionPicker
            type={type}
            defaultValue={apiVersion}
            versions={apiVersions}
            displayAppName="API"
            appName="api"
          />
          <VersionPicker
            type={type}
            defaultValue={calendarVersion}
            versions={calendarVersions}
            displayAppName="Calendar"
            appName="calendar"
          />
          <VersionPicker
            type={type}
            defaultValue={checkInsVersion}
            versions={checkInsVersions}
            displayAppName="Check-Ins"
            appName="check_ins"
          />
          <VersionPicker
            type={type}
            defaultValue={groupsVersion}
            versions={groupsVersions}
            displayAppName="Groups"
            appName="groups"
          />
          <VersionPicker
            type={type}
            defaultValue={givingVersion}
            versions={givingVersions}
            displayAppName="Giving"
            appName="giving"
          />
          <VersionPicker
            type={type}
            defaultValue={peopleVersion}
            versions={peopleVersions}
            displayAppName="People"
            appName="people"
          />
          <VersionPicker
            type={type}
            defaultValue={publishingVersion}
            versions={publishingVersions}
            displayAppName="Publishing"
            appName="publishing"
          />
          <VersionPicker
            type={type}
            defaultValue={registrationsVersion}
            versions={registrationsVersions}
            displayAppName="Registrations"
            appName="registrations"
          />
          <VersionPicker
            type={type}
            defaultValue={servicesVersion}
            versions={servicesVersions}
            displayAppName="Services"
            appName="services"
          />
        </TileView>
      </div>
    )
  }
}

export default AppVersions
